import * as React from 'react';
import { Colors } from '../styles';
export const Expand = ({ width = 48, height = 48, color = 'GRAY_DARKEST' }) => (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M12.5 2.5v20", stroke: "#222", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m16.5 18.5-4 4-4-4M8.5 6.5l4-4 4 4", stroke: color ? Colors[color] : Colors.GRAY_DARKEST, strokeMiterlimit: 10, strokeLinecap: "square" })));
export default Expand;
//# sourceMappingURL=Expand.js.map